import { useMutation } from "@tanstack/react-query";
import { useClient } from "../context/auth-context";
import {
  parseAddressInfoResponse,
  parseApiResponse,
  parseDeliveryFeeEstimateResponse,
} from "../models";

export function useGetDestinations({ ...config }) {
  const client = useClient();

  return useMutation(
    ({ orgId, accessPointId, token }) => {
      const url = `geo/organisation/${orgId}/point/${accessPointId}/destinations`;
      const requestConfig = {
        method: "GET",
      };

      if (token) {
        requestConfig.headers = {
          Authorization: `Bearer ${token}`,
        };
      }

      return client(url, requestConfig).then(parseApiResponse);
    },
    {
      ...config,
    },
  );
}

export function useGetAddressCoordinates({ ...config }) {
  const client = useClient();
  return useMutation(
    async ({ address }) => {
      const url = `geo/geocode?address=${address}`;
      const requestConfig = {
        method: "GET",
      };

      const res = await client(url, requestConfig);
      return res;
    },
    {
      ...config,
    },
  );
}

export function useGetGeoAddressInfo({ ...config }) {
  const client = useClient();
  return useMutation(
    async ({ address, signal }) => {
      const url = `geo/address/info?address=${encodeURIComponent(address)}`;
      const requestConfig = {
        method: "GET",
        signal,
      };

      const res = await client(url, requestConfig);
      return parseAddressInfoResponse(res);
    },
    {
      ...config,
    },
  );
}

export function useEstimateDeliveryFee({ ...config }) {
  const client = useClient();
  return useMutation(
    async (data) => {
      const { signal, ...payload } = data || {};
      const requestConfig = {
        method: "POST",
        data: payload,
        signal,
      };

      const endpoint = "geo/delivery/fee/estimate";
      const res = await client(endpoint, requestConfig);
      return parseDeliveryFeeEstimateResponse(res);
    },
    {
      ...config,
    },
  );
}
